module.exports = __webpack_public_path__ + "img/1.ec44aaf6.jpg";